// removed by extract-text-webpack-plugin
module.exports = {"grey":"#707070","light-grey":"#d4d4d4","red":"#e40000","white":"#ffffff","ipad-portrait":"768px","ipad":"1024px","desktop":"1366px","header":"VuHljhxj1TPRUPs-OTwC9","hidden":"_2N_zDFbuD81GHxA6lw9fdj","wrapper":"s2EJDGJ49mX1D7JcnFoxD","logoContainer":"fbBUA-QyirtwnP5ejrVOr","logo":"_1_8dXqmoJ0ibI3MXX4FBYX","landing":"K5Nk7rVnXENcrBzTiOaLz","navBar":"qrQ8iy76uOqn8JmigoMSY","secondaryMenu":"_1Bc5GpyqM9fmXwULueRP-m","secondaryLink":"_1DNdYplOl6pi4ddGnBDuP9","menu":"UGIbwME1fSQOY3N1mN7po","menuLink":"_1BFDy-lWmwcIpKa290zNYq","toggleMenu":"_38LRuOl30OmHGn8w3ItNWP"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Header/Header.css
// module id = 1337
// module chunks = 0